import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Spinner from 'assets/img/spinner.svg';

const styles = {
	svgContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: 'inherit',
	},
};

export class LoadingIndicator extends Component {
	render() {
		const { classes } = this.props;
		return (
			<div className={classes.svgContainer}>
				<img
					src={Spinner}
					alt='spinner'
				/>
			</div>
		)
	}
}

export default withStyles(styles)(LoadingIndicator)
